import { CloseRoundIcon, ErrorRoundIcon, SuccessRoundIcon } from 'common/Icons';

interface RadioValidateType {
  value: string;
}

export const RadioValidate = ({ value }: RadioValidateType) => {

  const roundIcon = (reg1: RegExp) => {
    if (value === '') {
      return <CloseRoundIcon />;
    }
    if (!reg1?.test(value)) {
      return <ErrorRoundIcon />;
    } else {
      return <SuccessRoundIcon />;
    }
  };

  return (
    <div className="flex justify-start md:gap-x-20 gap-x-10 gap-y-2 row flex-wrap  my-3">
      <div className="flex justify-start items-center gap-1 mt-1 max-[390px]:ml-[21px]">
        {roundIcon(/^[×a-zA-Z0-9!@#$%^&*()[\]{};'\\/\-_+=.,<>|":;]+$/gi)}
        <span className="text-base">فقط حروف انگلیسی</span>
      </div>
      <div className="flex justify-start items-center gap-1 mt-1 mr-[21px] max-[390px]:mr-0">
        {roundIcon(/(?=.*[a-z])(?=.*[A-Z])/g)}
        <span className="text-base">شامل حروف بزرگ و کوچک انگلیسی</span>
      </div>
      <div className="flex justify-start items-center gap-1 mt-1">
        {roundIcon(/(?=.*[1-9])(?=.*[!@#$%^&*(),.?":{}|<>])/g)}
        <span className="text-base">شامل عدد و کاراکتر خاص</span>
      </div>
      <div className="flex justify-start items-center gap-1 mt-1">
        {roundIcon(/.{8,}/i)}
        <span className="text-base ml-4">حداقل ۸ کاراکتر</span>
      </div>
    </div>
  );
};
